import { initContract } from '@ts-rest/core';
import { z } from 'zod';

import { SortDirection } from '@e-origin/shared';

const c = initContract();

const ERROR_MESSAGE_REQUIRED = 'Error message cannot be empty';

const CustomsErrorShape = z.object({
  _id: z.any().optional(),
  declarationAttributePointer: z.string().optional(),
  errorMessage: z.string().min(1, ERROR_MESSAGE_REQUIRED),
  errorReason: z.string().min(1, ERROR_MESSAGE_REQUIRED),
  runCustomsSyncByLRN: z.boolean().optional(),
  createdAt: z.string().or(z.date()).optional(),
  updatedAt: z.string().or(z.date()).optional(),
});

export const customsErrorContract = c.router({
  retrieveCustomsErrors: {
    method: 'POST',
    path: '/customs-error',
    body: z.object({
      criteria: z
        .object({
          filters: z.object({ searchQuery: z.string().optional() }).optional(),
          pagination: z.object({ page: z.number().optional(), size: z.number().optional() }).optional(),
          sorting: z.object({ field: z.string().optional(), direction: z.enum([SortDirection.ASC, SortDirection.DESC]).optional() }).optional(),
        })
        .optional(),
    }),
    responses: {
      201: z.object({
        data: z.object({
          customsErrors: z.array(CustomsErrorShape),
          totalItems: z.number(),
        }),
      }),
    },
  },
  createCustomsError: {
    method: 'POST',
    path: '/customs-error/add',
    body: z.object({
      declarationAttributePointer: z.string(),
      errorMessage: z.string().min(1, ERROR_MESSAGE_REQUIRED),
      errorReason: z.string().min(1, ERROR_MESSAGE_REQUIRED),
      runCustomsSyncByLRN: z.boolean(),
    }),
    responses: {
      201: z.object({ data: CustomsErrorShape }),
    },
  },
  editCustomsError: {
    method: 'POST',
    path: '/customs-error/edit/:id',
    pathParams: z.object({ id: z.string() }),
    body: z.object({
      declarationAttributePointer: z.string().optional(),
      errorMessage: z.string().min(1, ERROR_MESSAGE_REQUIRED).optional(),
      errorReason: z.string().min(1, ERROR_MESSAGE_REQUIRED).optional(),
      runCustomsSyncByLRN: z.boolean().optional(),
    }),
    responses: {
      201: z.object({ data: z.any() }),
    },
  },
  deleteCustomsError: {
    method: 'DELETE',
    path: '/customs-error/:id',
    pathParams: z.object({ id: z.string() }),
    body: c.noBody(),
    responses: {
      204: c.noBody(),
    },
  },
  exportCustomsErrors: {
    method: 'POST',
    path: '/customs-error/export',
    body: z.object({ ids: z.array(z.string()) }),
    responses: {
      200: c.otherResponse({ contentType: 'application/json', body: z.any() }),
    },
  },
  importCustomsErrors: {
    method: 'POST',
    path: '/customs-error/import',
    body: c.noBody(),
    responses: {
      201: z.object({ message: z.string() }),
    },
  },
});
